import React from 'react';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = Pick<
  MuiButtonProps,
  | 'startIcon'
  | 'fullWidth'
  | 'type'
  | 'disabled'
  | 'href'
  | 'onClick'
  | 'className'
  | 'children'
  | 'sx'
> & {
  shape?: 'square' | 'round';
  color?: 'primary' | 'secondary';
};
export const Button = ({
  children,
  color = 'primary',
  disabled,
  fullWidth,
  href,
  onClick,
  startIcon,
  shape = 'square',
  type,
  sx,
}: ButtonProps) => {
  return (
    <MuiButton
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      href={href}
      onClick={onClick}
      startIcon={startIcon}
      variant="contained"
      type={type}
      sx={{
        height: '48px',
        fontWeight: '500',
        borderRadius: shape === 'round' ? 100 : '8px',
        ...sx,
      }}
    >
      {children}
    </MuiButton>
  );
};
